import * as React from 'react'
import './styles.scss'

const InputWrapper = ({
  children,
  meta,
  isDisabled,
}: {
  children: any
  meta: any
  // tslint:disable-next-line
  isDisabled: boolean
}) => {
  return (
    <div className="inputWrapper">
      {children}
      {meta.visited && meta.invalid && (
        <div className="errorWrapper">
          <div>{meta.error}</div>
        </div>
      )}
    </div>
  )
}

export default InputWrapper
